// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Uxkk","inner":"Footer_inner__PQHc3"};